import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { tabelaPrecoPromocao, tabelaPrecoAdesaoTodas, BuscaPlanoTabelaPreco } from '../../modulos/function/promocaoCidade';

export const estado = [

    {
        id: 12,
        label: 'Acre',
        value: 'AC'
    },
    {
        id: 27,
        label: 'Alagoas',
        value: 'AL'
    },
    {
        id: 13,
        label: 'Amazonas',
        value: 'AM'
    },
    {
        id: 16,
        label: 'Amapá',
        value: 'AP'
    },
    {
        id: 29,
        label: 'Bahia',
        value: 'BA'
    },
    {
        id: 23,
        label: 'Ceará',
        value: 'CE'
    },
    {
        id: 53,
        label: 'Distrito Federal',
        value: 'DF'
    },
    {
        id: 32,
        label: 'Espírito Santo',
        value: 'ES'
    },
    {
        id: 52,
        label: 'Goiás',
        value: 'GO'
    },
    {
        id: 21,
        label: 'Maranhão',
        value: 'MA'
    },
    {
        id: 50,
        label: 'Mato Grosso do Sul',
        value: 'MS'
    },
    {
        id: 51,
        label: 'Mato Grosso',
        value: 'MT'
    },
    {
        id: 31,
        label: 'Minas Gerais',
        value: 'MG'
    },
    {
        id: 15,
        label: 'Pará',
        value: 'PA'
    },
    {
        id: 41,
        label: 'Paraná',
        value: 'PR'
    },
    {
        id: 25,
        label: 'Paraíba',
        value: 'PB'
    },
    {
        id: 26,
        label: 'Pernambuco',
        value: 'PE'
    },
    {
        id: 22,
        label: 'Piauí',
        value: 'PI'
    },
    {
        id: 33,
        label: 'Rio de Janeiro',
        value: 'RJ'
    },
    {
        id: 24,
        label: 'Rio Grande do Norte',
        value: 'RN'
    },
    {
        id: 43,
        label: 'Rio Grande do Sul',
        value: 'RS'
    },
    {
        id: 11,
        label: 'Rondônia',
        value: 'RO'
    },
    {
        id: 14,
        label: 'Roraima',
        value: 'RR'
    },
    {
        id: 42,
        label: 'Santa Catarina',
        value: 'SC'
    },
    {
        id: 35,
        label: 'São Paulo',
        value: 'SP'
    },
    {
        id: 28,
        label: 'Sergipe',
        value: 'SE'
    },
    {
        id: 17,
        label: 'Tocantins',
        value: 'TO'
    }
];

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {' '}
            {value === index && (
                <Box p={3}>
                    <Typography> {children} </Typography>{' '}
                </Box>
            )}{' '}
        </div>
    );
}

export function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`
    };
}

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        flexGrow: 1,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(1)
        },
        width: '100%',
        margin: 'auto',
        marginLeft: '1%'
    },
    label: {
        fontSize: '16px',
        color: '#373737'
    },
    input: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    Autocomplete: {
        marginTop: '10px'
    },
    buttons: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '-1.6%',
        marginTop: '6px'
    },
    buttonSearch: {
        color: '#101C85',
        borderColor: '#101C85',
        marginLeft: '10px'
    }
}));

export function ufBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Estado(UF)</span>
            {rowData.UF}
        </React.Fragment>
    );
}

export function cidadeBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Cidade</span>
            {rowData?.CidadesIBGE?.NOME}
        </React.Fragment>
    );
}

export function macroRegBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Macro Região</span>
            {rowData.macro_regiao}
        </React.Fragment>
    );
}

export function valorBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Novo</span>
            {new Intl.NumberFormat('pt-BR', { style: 'currency',
                currency: 'BRL' }
            ).format(rowData.adesao_novo)}

        </React.Fragment>
    );
}

export function TrocaBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title"> Troca</span>
            {new Intl.NumberFormat('pt-BR', { style: 'currency',
                currency: 'BRL' }
            ).format(rowData.adesao_troca)}
        </React.Fragment>
    );
}

export function ReabBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title"> Reabilitação </span>
            {new Intl.NumberFormat('pt-BR', { style: 'currency',
                currency: 'BRL' }
            ).format(rowData.adesao_reab)}
        </React.Fragment>
    );
}

export function CremaçãoBody(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title"> Cremação </span>
            {new Intl.NumberFormat('pt-BR', { style: 'currency',
                currency: 'BRL' }
            ).format(rowData.adesao_cremacao)}
        </React.Fragment>
    );
}

export function carenciaComProBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Carência com Promoção</span>
            {`${rowData.carencia_promocional} dias`}
        </React.Fragment>
    );
}

export function carenciaSemProBodyTemplate(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Carência sem Promoção</span>
            {`${rowData.carencia} dias`}
        </React.Fragment>
    );
}

export function valorBaseMensalidade(rowData) {
    return (
        <React.Fragment>
            <span className="p-column-title">Valor Base</span>
            {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.valorBase)}
        </React.Fragment>
    );
}

export function valorDescontoMensalidadeCartao(rowData) {
    return (
        <React.Fragment>
            <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Cartão</span>
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.descontoCartao?.valor ?? 0)}
            </div>
            {rowData.descontoCartao?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    {`${String(new Date(rowData.descontoCartao.vigenciaInicio).toLocaleDateString('pt-BR'))} até
            ${String(new Date(rowData.descontoCartao.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                </div>            :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export function valorDescontoMensalidadeBoleto(rowData) {
    return (
        <React.Fragment>

            <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Boleto</span>
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.descontoBoleto?.valor ?? 0)}
            </div>
            {rowData.descontoBoleto?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    {`${String(new Date(rowData.descontoBoleto.vigenciaInicio).toLocaleDateString('pt-BR'))} até
            ${String(new Date(rowData.descontoBoleto.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                </div>            :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export function valorDescontoMensalidadeEscelsa(rowData) {
    return (
        <React.Fragment>
            {rowData.UF ==='ES' ? <div className='datatable-body'>
                <span className="p-column-title">Valor do desconto Escelsa</span>
                {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(rowData.descontoEscelsa?.valor ?? 0)}
            </div> :
                <span>
                Não se aplica
                </span>}

            {rowData.descontoEscelsa?.vigenciaInicio ?
                <div className='datatable-body'>
                    <span className="p-column-title">Vigência Desconto</span>
                    {`${String(new Date(rowData.descontoEscelsa.vigenciaInicio).toLocaleDateString('pt-BR'))} até
            ${String(new Date(rowData.descontoEscelsa.vigenciaFim).toLocaleDateString('pt-BR'))}`}
                </div>            :
                <span>
                </span>
            }
        </React.Fragment>
    );
}

export async function BuscaPlanos(uf, arrayCidade, valorDigitado, plano, pagina) {
    let tipo = 'cidade';
    let valor;
    let codCidade;
    let cidadeUf;

    if ( uf == undefined && !valorDigitado && plano !== 'Plano'  )  {
        return await tabelaPrecoAdesaoTodas(pagina);
    } else if (uf == undefined && !valorDigitado && plano === 'Plano') {
        return await BuscaPlanoTabelaPreco(pagina);
    } else {
        if (uf && arrayCidade.length < 1) {
            tipo = 'UF';
            valor = uf;
        } else if (uf && arrayCidade.length > 0) {
            cidadeUf = valorDigitado.slice(0, -4);
            codCidade = arrayCidade.find(item => item.CidadesIBGE.NOME == cidadeUf);
            valor = codCidade.CidadesIBGE.ID;
        } else {
            cidadeUf = valorDigitado.split('(');

            const cidade = cidadeUf[0];
            let ufCidade = cidadeUf[1];

            ufCidade = ufCidade.slice(0, -1);
            codCidade = arrayCidade.find(item => item.CidadesIBGE.NOME == cidade && item.UF == ufCidade);
            valor = codCidade.CidadesIBGE.ID;
        }

        return await tabelaPrecoPromocao(true, tipo, valor, plano, '', pagina);
    }
}

export async function BuscarNomeCidades(valorDigitado, setArrayCidade, plano) {
    plano = (plano === 'Mensalidade') ? 'Plano' : plano;

    const cidades = await tabelaPrecoPromocao(false, 'cidade', valorDigitado, plano);

    setArrayCidade(cidades);

    const filtroCidadeDuplicado = cidades.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    const cidadeUf = [];

    await filtroCidadeDuplicado.map(item => {
        cidadeUf.push(`${item.CidadesIBGE.NOME}(${item.UF})`);
    });

    return { cidadeUf,
        cidades };
}
